import { AfterViewInit, Component, Input, OnInit } from "@angular/core";
import { Address, Cryptocoin } from "@models";
import { UserService } from "../../services/user.service";
import { config } from "@config";
import { TranslationService } from "@core-services/translation.service";
import { CryptocoinService } from "../../services/currency";
import { AssetInfoService } from "@main-services/split-data/asset-info.service";
import { LaunchDarklyService, LD_FLAG } from "@core-services/launch-darkly/launch-darkly.service";
import { Observable } from "rxjs";
import { WalletDetailsTrackingService } from "@main-services/wallet/wallet-details-tracking.service";

@Component({
	selector: "crypto-qr",
	templateUrl: "./crypto-qr.component.html",
	styleUrls: ["./crypto-qr.component.scss"],
	providers: [WalletDetailsTrackingService],
	standalone: false
})
export class CryptoQRComponent implements OnInit, AfterViewInit {
	public constructor(
		private userService: UserService,
		private translationService: TranslationService,
		private cryptoCoinService: CryptocoinService,
		private launchDarkly: LaunchDarklyService,
		private assetInfoService: AssetInfoService,
		private walletDetailsTrackingService: WalletDetailsTrackingService
	) {}

	@Input()
	public warning: string = "";

	@Input()
	public coin: Cryptocoin = null;

	@Input()
	public cssStyle: string = "";

	@Input()
	public address: Address;

	@Input()
	public address_info: string = "";

	@Input()
	public coinSymbol: string = "";

	@Input()
	public networkName: string = "";

	@Input()
	public cryptocoinIcon: string = "";
	@Input()
	public networkIcon: string = "";
	public isMultichainEnabled: Observable<boolean>;

	public get limitsLink(): string {
		return config.baseUrl + this.userService.user.getLanguage(true) + "/limits#transactioncosts";
	}

	public ngOnInit(): void {
		this.assetInfoService.fetchApiInfo(this.coin);
		this.isMultichainEnabled = this.launchDarkly.isActive$(LD_FLAG.DEPOSIT_MULTICHAIN);
		this.walletDetailsTrackingService.trackWalletAddressViewed(this.coin.getSymbol().toUpperCase());
	}

	public ngAfterViewInit(): void {
		if (this.coinSymbol.length > 0 && this.coin == null) {
			this.coin = this.cryptoCoinService.findBySymbol(this.coinSymbol);
		}
	}

	public get extraInfo(): string {
		if (!this.coin) {
			return "";
		}
		return this.coin.getExtraInfo();
	}

	public trackCopyAddress(): void {
		this.walletDetailsTrackingService.trackCopyWalletAddress();
	}

	public trackCopyInfo(infoType: string): void {
		if (infoType === "stellar_memo") {
			this.walletDetailsTrackingService.trackCopyMemo();
		} else {
			this.walletDetailsTrackingService.trackCopyDestinationTag();
		}
	}

	public showLastUsed(): boolean {
		if (this.address) {
			return this.address.getLastUpdated().getUnix() > this.address.getGeneratedAt().getUnix();
		}
		return false;
	}

	public destinationTagLabel(): string {
		let label = "destination_tag";
		if (this.coin != null) {
			if (this.coin.isStellar()) {
				label = "stellar_memo";
			} else if (this.coin.getSupportsDestinationTag()) {
				label = this.coin.getSymbol(true) + "_" + label;
			}
		}
		return label;
	}

	public getSupportAddressUrl(): string {
		return this.translationService.getHdLink() + config.externalPaths["cryptoQr"]["hdLink"];
	}

	public getCode(): string {
		const name =
			this.coin.getSymbol().toLowerCase() === "eth" || this.address.getAddress().startsWith("0x")
				? "ethereum"
				: this.coin.getName().toLowerCase();
		return `${name}:${this.address.getAddress()}`;
	}

	public openAddress(): void {
		window.open(this.getCode());
	}
}
